import React from "react";
import { Box } from "@mui/material";
import TrendCard from "./TrendCard";
import WorkOrdersStatusList from "./WorkOrdersStatusList";

const TrendPanelsRow = ({ maintenanceByMonth, violationsByYearChart, architecturalRequestsByYearChart }) => (
  <Box sx={{
    display: "grid",
    gridTemplateColumns: { xs: "1fr", sm: "repeat(2, 1fr)", lg: "repeat(4, 1fr)" },
    gap: 2.5, mb: 3,
  }}>
    <TrendCard title="Work orders by month" data={maintenanceByMonth} color="#2f63ad" />
    <TrendCard title="Violations by month" data={violationsByYearChart} color="#dc2626" />
    <TrendCard title="Architectural requests by month" data={architecturalRequestsByYearChart} color="#b45309" />
    <WorkOrdersStatusList />
  </Box>
);

export default TrendPanelsRow;
